/**
 * TOS gate resolution for the chat composer.
 *
 * The acceptance flag has THREE meaningful states, not two:
 *
 *   true      → accepted; allow the send
 *   false     → known, not accepted; the TosModal is open and the user must act
 *   undefined → UNKNOWN; the status request failed and we have no answer
 *
 * Conflating `undefined` with `false` is what caused IPA-TOS-SILENT: a single
 * failed `GET /api/v1/ai/tos/status` left `tosStatus` undefined, and a truthiness
 * check (`if (!tosStatus?.accepted) return;`) swallowed every send with no modal,
 * no error, and no network request. The widget looked completely dead while the
 * platform was healthy.
 *
 * Keep the three states distinct. `undefined` is a recoverable error the user
 * must be told about — it is not a denial.
 */
/**
 * Message shown when we cannot determine TOS acceptance. Deliberately actionable:
 * the query self-heals on window refocus, but a user staring at a dead composer
 * has no way to know that, so we tell them to retry.
 */
export const TOS_STATUS_UNAVAILABLE_MESSAGE = "I couldn't verify your Terms of Service acceptance, so I didn't send that message. " +
    'This is usually a temporary connection problem. Please try again, or reload the page if it keeps happening.';
/**
 * @param accepted `tosStatus?.accepted` — boolean when known, undefined when the
 *   status query has not resolved or has errored.
 * @returns which branch the composer should take.
 */
export function resolveTosGate(accepted) {
    if (accepted === true)
        return 'allow';
    if (accepted === false)
        return 'blocked-awaiting-acceptance';
    return 'blocked-status-unknown';
}
